import Model, { encoders, ID } from 'src/models/model'
import IssuedVoucherPackage from 'src/models/voucher/IssuedVoucherPackage'
import Voucher from 'src/models/voucher/Voucher'

export default class IssuedVoucherPackageVoucher extends Model {
  static name = 'IssuedVoucherPackageVoucher'

  static versioned = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      voucher: {
        type: Voucher,
        reference: true
      },
      issuedVoucherPackage: {
        type: IssuedVoucherPackage,
        default: null,
        encode: encoders.hasOne,
        reference: true
      }
    }
  }
}
